import { render, staticRenderFns } from "./expressDialog.vue?vue&type=template&id=5347a41d"
import script from "./expressDialog.vue?vue&type=script&lang=js"
export * from "./expressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports